<template>
  <div class="suggestion-list">
    <v-container class="py-1 px-3 bg-grey-lighten-4" fluid>
      <warehouse-select />
      <filter-list :store="suggestionsStore" v-if="!suggestionsStore.loading && suggestionsStore.displayFilters.length > 0" />
    </v-container>
    <template v-if="!suggestionsStore.loading && !suggestionsStore.error">
      <v-list lines="two" class="pa-0 border-t">
        <template v-if="suggestionsStore.data">
          <!-- changed BelegNr to BuchungNr. -->
          <template
            v-for="suggestion in suggestionsStore.data"
            :key="suggestion.BuchungNr">
            <hr
              role="separator"
              aria-orientation="horizontal"
              class="v-divider"
              theme="light"
            />
            <suggestion-list-item :suggestion="suggestion" />
            <hr
              role="separator"
              aria-orientation="horizontal"
              class="v-divider"
              theme="light"
            />
          </template>
        </template>
        <v-container fluid class="mb-10">
          <pagination :module="suggestionsStore.$id" />
        </v-container>
      </v-list>
    </template>
    <template v-else-if="suggestionsStore.error">
      <v-container class="py-1" fluid>
        <error :module="suggestionsStore.$id" />
      </v-container>
    </template>
    <template v-else>
      <loading />
    </template>
    <v-btn
      position="fixed"
      icon
      class="ma-3"
      style="z-index: 1;"
      location="right bottom"
      @click="navigate({ name: 'suggestion_create' })"
      color="primary">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import FilterList from '@/components/FilterList.vue';
import ErrorComp from '@/components/Error.vue';
import Loading from '@/components/Loading.vue';
import Pagination from '@/components/Pagination.vue';
import WarehouseSelect from '@/components/WarehouseSelect.vue';
import SuggestionListItem from '@/components/Suggestion/SuggestionListItem.vue';
import {RouteLocationRaw} from 'vue-router';
import router from '@/router';
import useSuggestionsStore from '@/store/suggestions';
import {useStorage} from '@/composables/storage';

const suggestionsStore = useSuggestionsStore();
useStorage(suggestionsStore);
function navigate(to: RouteLocationRaw) {
  router.push(to).catch(console.error);
}

defineExpose({
  FilterList,
  Error: ErrorComp,
  Loading,
  Pagination,
  WarehouseSelect,
  SuggestionListItem,
  navigate,
  suggestionsStore,
});
</script>

<style>
.item-operator-info .v-chip__content {
  display: flex;
  justify-content: center;
}
.v-pagination__navigation, .v-pagination__item--active {
  box-shadow: none;
}
</style>
